const states = {
    posts:[],
    post: {},
    authData: null,
    isLoading: false,
}

export default states;